import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { FeriadoList } from '../../core/_models'
import { usePermissoesFeriado } from '../../core/usePermissoesFeriado'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { feriadosColumns } from './columns/_columns'

export const FeriadosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { podeEscrever } = usePermissoesFeriado()

  // Quem só tem `Feriado:read` não recebe a coluna de ações — sem ela a tabela
  // não fica com uma coluna vazia depois que as ações somem.
  const colunas = useMemo(
    () => (podeEscrever ? feriadosColumns : feriadosColumns.filter((c) => c.id !== 'actions')),
    [podeEscrever]
  )

  return (
    <CustomTable<FeriadoList>
      id='kt_table_feriados'
      ariaLabel='Feriados'
      itemLabel={{ singular: 'feriado', plural: 'feriados' }}
      data={response?.data || []}
      columns={colunas}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhum feriado cadastrado'
          description={
            podeEscrever
              ? 'Use “Novo feriado” para bloquear um dia na agenda.'
              : 'Os feriados cadastrados pelo administrador aparecem aqui.'
          }
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
